import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { AgoFilter } from './pipes/agofilter';
import { CreateNoticeComponent } from './modals/create-notice/create-notice.component';
import { QuizModalComponent } from './modals/quiz-modal/quiz-modal.component';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ],
    declarations: [
        AgoFilter,
        CreateNoticeComponent,
        QuizModalComponent
    ],
    entryComponents: [],
    exports: [
        AgoFilter,
        CreateNoticeComponent
    ]
})
export class ApplicationPageModule {

}